import React from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography, Divider, Box, TableContainer, TableHead, TableBody, TableCell, Table, TableRow, Paper } from '@mui/material'
import { useTenantFormContext } from '../tenant-form-context'
import { ActionButton } from '@emerald-works-nova/components'
import { CheckRounded, ClearRounded } from '@mui/icons-material'

const ContentHubConfirmationModal = ({ open, onClose, handleConfirmation }) => {
  const { isEdit, getValues } = useTenantFormContext()
  const templateName = getValues('templateName')
  const tenantData = getValues()
  const { features } = tenantData

  const rows = [
    { name: 'Content Hub', status: features.contentHub },
    { name: 'Skill Bites', status: features.skillBite?.enabled },
    { name: 'Accelerate', status: features.accelerate?.enabled },
    { name: 'MSA', status: features?.assessment?.enabled ?? features.msa },
    { name: 'MSB', status: features.msb },
    { name: 'Mindtools App', status: features.mobileApp },
    { name: 'AI Skills Practice', status: features.skillsPractice?.enabled }
  ]

  const confirm = () => {
    handleConfirmation()
    onClose()
  }

  const renderContent = () => {
    if (isEdit) {
      return (
        <Box display='flex' flexDirection='column' gap={2}>
          <Typography>
            You're activating the Content Hub for this Toolkit for the first time. <br />
          </Typography>
          <Typography>
            Base template selected: <span><strong>{templateName}</strong></span>
          </Typography>
          <Typography>
            Please, note that selecting a Template for a Toolkit is an irreversible action.
          </Typography>
          <Typography>
            Also, the Content Hub might take around 30 minutes to be fully available on the Toolkit.
          </Typography>
          <Typography>
            Are you sure you want to update this Toolkit?
          </Typography>
        </Box>
      )
    }

    return (
      <Box>
        <Typography>
          You're creating a new Toolkit with this configuration:
        </Typography>
        <TableContainer
          component={Paper} sx={{ marginTop: 2 }}
          data-test='toolkit-creation-confirmation-products-table'
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align='center'>Product</TableCell>
                <TableCell align='center'>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow key={row.name}>
                  <TableCell align='center' sx={{ fontWeight: 500 }}>{row.name}</TableCell>
                  <TableCell align='center'>
                    {row.status ? <CheckRounded color='success' />
                      : <ClearRounded color='error' />}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {features.contentHub && (
          <Box mt={2}>
            <Typography>
              You've selected the <span><strong>{templateName}</strong></span> as the base template for this Toolkit.
            </Typography>
          </Box>
        )}
        {(features?.assessment?.enabled ?? features?.msa) && (
          <Box mt={2}>
            <Typography>
              MSA will be enabled with the default settings. You'll be able to change it later.
            </Typography>
          </Box>
        )}
        <Box mt={2}>
          <Typography>
            Are you sure you want to create this Toolkit?
          </Typography>
        </Box>
      </Box>
    )
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      closeAfterTransition
      fullWidth
      maxWidth='sm'
      data-test={isEdit ? 'content-hub-activation-modal' : 'toolkit-creation-modal'}
    >
      <DialogTitle>
        {isEdit ? 'Content Hub Activation Confirmation' : 'Toolkit Creation Confirmation'}
      </DialogTitle>
      <Divider />
      <DialogContent>
        {renderContent()}
      </DialogContent>
      <DialogActions sx={{ display: 'flex', justifyContent: 'space-between', padding: 2 }}>
        <ActionButton
          onClick={onClose} variant='secondary' label='Cancel'
          dataTest={isEdit ? 'content-hub-activation-modal-cancel' : 'toolkit-creation-modal-cancel'}
        >
          Cancel
        </ActionButton>
        <ActionButton
          onClick={confirm} variant='primary'
          dataTest={isEdit ? 'content-hub-activation-modal-confirm' : 'toolkit-creation-modal-confirm'}
        >
          {isEdit ? 'Save' : 'Create'}
        </ActionButton>
      </DialogActions>
    </Dialog>
  )
}

export default ContentHubConfirmationModal
